import { Dayjs } from "dayjs";
import { PostImageItem as CommonPostImageItem } from "../../util/types";
import { UserEntity } from "./editors";

// 投票の項目数
export const MIN_VOTE_OPTIONS_COUNT = 2
export const MAX_VOTE_OPTIONS_COUNT = 5

export type Attachment = {
  id: number;
  name: string | undefined;
  file: any;
  _destroy: string | undefined;
};

export type PostImageItem = CommonPostImageItem;

export type Errors = {
  title: string,
  category: string,
  group: string,
  details: string,
  tags: string,
  images: string,
  attachments: string,
  acceptVotes: string,
  acceptComments: string,
  agree: string,
  date: string,
  voteSetting: {
    voteQuestion: string;
    voteOptions: { optionText: string }[];
    limitVoteOptions: string;
    expiryDate: string;
  },
}

export type Tag = {
  id?: number
  tag: string
  _destroy?: string
}

export type VoteOption = {
  id?: number;
  optionText: string;
  isVoted: boolean;
  key: string;
  _destroy: number;
}

export type PrivateUser = Omit<UserEntity, 'userType'> & {
  id?: number, // post_private_user.id
  userType: string
}

export type PostState = {
  id?: number,
  user: any,
  title: string,
  category: string,
  group: string,
  details: string,
  tags: Tag[],
  images: PostImageItem[],
  attachments: Attachment[],
  acceptComments: boolean,
  acceptVotes: boolean,
  showNameOption: number,
  isPrivate: boolean,
  privateUsers: PrivateUser[]
  voteSetting: {
    voteQuestion: string,
    voteOptions: VoteOption[],
    expiryDate?: Dayjs,
  },
  changabled: {
    voteSetting: boolean,
  }
}

export const initialVoteSettingErrors = (length: number) => {
  return {
    voteQuestion: "",
    voteOptions: Array.from({ length: length}, () => {
      return {
        optionText: "",
      }
    }),
    limitVoteOptions: "",
    expiryDate: "",
  }
}

export const isSamePrivateUser = (privateUser: PrivateUser, userClassName: string, userId: number)=> {
  if (!userClassName || !userId) return false
  return privateUser.userType === userClassName && privateUser.userId === userId
}
